import React from 'react';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

  .static-page {
    font-family: 'Inter', system-ui, sans-serif;
    background: #0a0f1e;
    min-height: 100vh;
    color: #e2e8f0;
  }

  /* Hero strip */
  .static-hero {
    background: linear-gradient(160deg, #0f172a 0%, #1e1b4b 50%, #0a0f1e 100%);
    padding: 80px 24px 70px;
    text-align: center;
    position: relative;
    overflow: hidden;
    border-bottom: 1px solid rgba(99,102,241,0.15);
  }

  .static-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse 70% 60% at 50% -10%, rgba(99,102,241,0.18) 0%, transparent 70%);
    pointer-events: none;
  }

  .static-label {
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: #a5b4fc;
    background: rgba(99,102,241,0.1);
    border: 1px solid rgba(99,102,241,0.25);
    border-radius: 100px;
    padding: 4px 14px;
    margin-bottom: 20px;
  }

  .static-hero h1 {
    font-size: clamp(2rem, 5vw, 3.2rem);
    font-weight: 900;
    color: #f1f5f9;
    margin: 0 0 16px;
    letter-spacing: -0.03em;
  }

  .static-hero h1 span {
    background: linear-gradient(135deg, #818cf8, #6366f1);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .static-hero-sub {
    font-size: 1.1rem;
    color: #64748b;
    max-width: 540px;
    margin: 0 auto;
    line-height: 1.7;
  }

  /* Content wrapper */
  .static-body {
    max-width: 800px;
    margin: 0 auto;
    padding: 64px 24px 100px;
  }

  /* Section cards */
  .static-card {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(99,102,241,0.12);
    border-radius: 20px;
    padding: 40px;
    margin-bottom: 28px;
    transition: border-color 0.3s;
  }

  .static-card:hover {
    border-color: rgba(99,102,241,0.25);
  }

  .static-card h2 {
    font-size: 1.25rem;
    font-weight: 800;
    color: #f1f5f9;
    margin: 0 0 16px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .static-card h2 .card-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px; height: 36px;
    background: rgba(99,102,241,0.15);
    border-radius: 10px;
    font-size: 18px;
    flex-shrink: 0;
  }

  .static-card p {
    font-size: 0.95rem;
    line-height: 1.8;
    color: #94a3b8;
    margin: 0 0 12px;
  }

  .static-card p:last-child { margin-bottom: 0; }

  /* Feature list */
  .feature-list {
    list-style: none;
    padding: 0;
    margin: 16px 0 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .feature-list li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 0.95rem;
    color: #94a3b8;
    line-height: 1.6;
  }

  .feature-list li::before {
    content: '';
    display: block;
    width: 6px; height: 6px;
    border-radius: 50%;
    background: #6366f1;
    flex-shrink: 0;
    margin-top: 8px;
    box-shadow: 0 0 6px #6366f1;
  }

  .feature-list li strong {
    color: #c7d2fe;
  }

  /* Pillars grid */
  .pillars-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-top: 8px;
  }

  @media (max-width: 560px) {
    .pillars-grid { grid-template-columns: 1fr; }
    .static-card { padding: 28px 20px; }
  }

  .pillar {
    background: rgba(99,102,241,0.06);
    border: 1px solid rgba(99,102,241,0.14);
    border-radius: 14px;
    padding: 20px;
  }

  .pillar-icon { font-size: 1.5rem; margin-bottom: 8px; }
  .pillar-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #e2e8f0;
    margin-bottom: 6px;
  }
  .pillar-desc { font-size: 0.875rem; color: #64748b; line-height: 1.6; }

  /* CTA strip */
  .static-cta {
    text-align: center;
    margin-top: 56px;
    padding: 48px 32px;
    background: linear-gradient(135deg, rgba(99,102,241,0.12), rgba(79,70,229,0.08));
    border: 1px solid rgba(99, 102, 241, 0.2);
    border-radius: 24px;
  }

  .static-cta h3 {
    font-size: 1.5rem;
    font-weight: 800;
    color: #f1f5f9;
    margin: 0 0 12px;
  }

  .static-cta p {
    font-size: 0.95rem;
    color: #64748b;
    margin: 0 0 28px;
  }

  .btn-primary {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, #6366f1, #4f46e5);
    color: white;
    text-decoration: none;
    padding: 14px 32px;
    border-radius: 12px;
    font-size: 0.95rem;
    font-weight: 700;
    transition: all 0.2s;
    box-shadow: 0 4px 20px rgba(99,102,241,0.35);
    font-family: inherit;
    border: none;
    cursor: pointer;
  }

  .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 32px rgba(99,102,241,0.55);
  }
`;

const About = () => (
  <div className="static-page">
    <style>{STYLES}</style>

    {/* Hero */}
    <div className="static-hero">
      <span className="static-label">About Us</span>
      <h1>Built to make links <span>work harder</span></h1>
      <p className="static-hero-sub">
        RDRTO is a URL shortening platform with real click analytics and smart link tools
        — built for anyone who shares links seriously.
      </p>
    </div>

    <div className="static-body">

      {/* What is RDRTO */}
      <div className="static-card">
        <h2><span className="card-icon">🔗</span>What is RDRTO?</h2>
        <p>
          <strong style={{ color: '#c7d2fe' }}>RDRTO</strong> stands for <strong style={{ color: '#c7d2fe' }}>ReDiRect TO</strong> — and that's exactly what it does.
          It takes any long, unwieldy link and turns it into a clean, trackable short URL you
          can share anywhere: social media, email, print, or messaging apps.
        </p>
        <p>
          We built RDRTO because we wanted a link shortener that was genuinely free to start,
          simple to use, and powerful enough for marketers, developers, and creators who care
          about where their links go and how they perform.
        </p>
      </div>

      {/* Mission */}
      <div className="static-card">
        <h2><span className="card-icon">🎯</span>Our Mission</h2>
        <p>
          To give everyone — from solo bloggers to growing teams — a reliable set of link
          management tools without paywalling the basics. Start free, upgrade only when you
          need more.
        </p>
      </div>

      {/* Features */}
      <div className="static-card">
        <h2><span className="card-icon">⚡</span>What You Get</h2>
        <p>Every account starts with the essentials, and grows with you:</p>
        <ul className="feature-list">
          <li><strong>Instant Link Shortening</strong> — Create a short link in seconds, no credit card required</li>
          <li><strong>Click Tracking</strong> — See how many times your link has been clicked</li>
          <li><strong>QR Code Generator</strong> — A downloadable QR code for every short link (free for a limited time)</li>
          <li><strong>Custom Aliases</strong> — Choose a memorable short code instead of a random one (Pro & Business)</li>
          <li><strong>Branded URLs</strong> — Use your own brand name in the link path or subdomain (Pro & Business)</li>
          <li><strong>Password Protection</strong> — Require a password before redirecting visitors (Pro & Business)</li>
          <li><strong>Expiration Dates</strong> — Automatically deactivate links after a set date (Pro & Business)</li>
          <li><strong>Advanced Analytics</strong> — Geographic click map, hourly and date-based click charts (Pro & Business)</li>
          <li><strong>Self-Healing Links</strong> — Automatically switch to a backup URL if your destination goes down (Pro & Business)</li>
          <li><strong>Link Intelligence Score</strong> — A health and trust rating for your destination URL (Business)</li>
        </ul>
      </div>

      {/* Pillars */}
      <div className="static-card">
        <h2><span className="card-icon">🛡</span>Why People Choose RDRTO</h2>
        <div className="pillars-grid">
          <div className="pillar">
            <div className="pillar-icon">🧩</div>
            <div className="pillar-title">Simple to Use</div>
            <p className="pillar-desc">Create a short link in a few clicks. No tutorials, no complexity.</p>
          </div>
          <div className="pillar">
            <div className="pillar-icon">🔒</div>
            <div className="pillar-title">Secure by Design</div>
            <p className="pillar-desc">HTTPS on every redirect, abuse detection, and optional password gating.</p>
          </div>
          <div className="pillar">
            <div className="pillar-icon">📈</div>
            <div className="pillar-title">Actionable Analytics</div>
            <p className="pillar-desc">Geographic click maps and time-based charts to understand your audience.</p>
          </div>
          <div className="pillar">
            <div className="pillar-icon">🏥</div>
            <div className="pillar-title">Self-Healing Links</div>
            <p className="pillar-desc">Links stay alive even when your destination goes down, automatically.</p>
          </div>
        </div>
      </div>

      {/* Contact */}
      <div className="static-card">
        <h2><span className="card-icon">📬</span>Get In Touch</h2>
        <p>
          Questions, ideas, or business inquiries? Head to our{' '}
          <a href="/contact" style={{ color: '#a5b4fc', textDecoration: 'none', fontWeight: 600 }}>Contact page</a>
          {' '}and we'll get back to you promptly.
        </p>
      </div>

      {/* CTA */}
      <div className="static-cta">
        <h3>Ready to shorten smarter?</h3>
        <p>Up to 20 free links to start. No credit card. No setup.</p>
        <a href="/signup" className="btn-primary">Create Your Free Account →</a>
      </div>

    </div>
  </div>
);

export default About;

